import React, { useEffect } from 'react'
import { graphql, navigate } from 'gatsby'

import TeaserTemplate from '../templates/Teaser'

const getRedirectLanguage = () => {
    if (typeof navigator === `undefined`) {
        return 'en'
    }

    const lang =
        navigator && navigator.language && navigator.language.split('-')[0]
    if (!lang) return 'en'

    switch (lang) {
        case 'de':
            return 'de'
        default:
            return 'en'
    }
}

export const IndexPage: React.FC<{
    data?: object
    location?: object
}> = ({ data, location }) => {
    useEffect(() => {
        const urlLang = getRedirectLanguage()
        const LanguageDetectedBefore = localStorage.getItem(
            'PazolaTeaserLanguageDetected'
        )
        if (urlLang != 'en' && !LanguageDetectedBefore) {
            navigate(`/${urlLang}`, { replace: true })
            localStorage.setItem('PazolaTeaserLanguageDetected', 'yes')
        }
    }, [])

    return <TeaserTemplate location={location} data={data} />
}

export const query = graphql`
    {
        contentfulTeaser(
            node_locale: { eq: "en-GB" }
            property: { name: { regex: "/pazola/i" } }
        ) {
            copy {
                childMarkdownRemark {
                    html
                }
            }
            title
            metaInformation {
                pageTitle
                pageImage {
                    fluid {
                        src
                    }
                }
                description {
                    childMarkdownRemark {
                        html
                    }
                }
            }
            visionTitle
            visionCopy {
                childMarkdownRemark {
                    html
                }
            }
            visionImage {
                desktopImage {
                    fluid(quality: 90, maxWidth: 1680) {
                        srcWebp
                        srcSetWebp
                        ...GatsbyContentfulFluid
                    }
                }
                mobileImage {
                    fluid(quality: 90, maxWidth: 750) {
                        srcWebp
                        srcSetWebp
                        ...GatsbyContentfulFluid
                    }
                }
            }
            visionButton {
                text
                buttonLink {
                    ... on ContentfulLink {
                        internalFile {
                            file {
                                url
                                contentType
                            }
                            title
                        }
                        externalLink
                    }
                }
            }
            contentBlocks {
                alignment
                title
                theme
                copy {
                    childMarkdownRemark {
                        html
                    }
                }
            }
        }
    }
`

export default IndexPage
